import { useFormik } from 'formik';
import * as Yup from 'yup';

import { useTranslation } from 'react-i18next';
import FormField from '../../../UI/FormUI/FormField/FormField';
import FormFileField from '../../../UI/FormUI/FormFileField/FormFileField';
import Button from '../../../UI/Buttons/Button/Button';

import styles from './PortfolioForm.module.css';

function PortfolioForm({ onSubmit, editItem, ...props }) {
    const { t } = useTranslation();
    const validationSchema = Yup.object({
        title: Yup.string().required(t('forms.portfolio.title_required')),
        description: Yup.string().required(t('forms.portfolio.description_required')),
        role: Yup.string().required(t('forms.portfolio.role_required')),
        media: !editItem && Yup.mixed()
            .fileSize(1024 * 1024 * 10, t('forms.portfolio.file_size_must_be_less_than_10MB'))
            .fileType(
                ['application/pdf', 'image/jpeg', 'image/png'],
                t('forms.portfolio.unsupported_file_format')
            )
            .required(t('forms.portfolio.media_required'))
    });

    const formik = useFormik({
        initialValues: {
            title: editItem?.title || '', // Prefill with editItem values or use empty string
            description: editItem?.description || '',
            role: editItem?.role || '',
            media: editItem?.media || '', // If editing, media fields will be prefilled
            media2: editItem?.media2 || '',
            media3: editItem?.media3 || '',
            media4: editItem?.media4 || '',
            media5: editItem?.media5 || '',

        },
        validationSchema: validationSchema,
        onSubmit: values => {
            onSubmit(values);
        },
    });

    return (
        <form onSubmit={formik.handleSubmit} {...props} style={{
            height: '70vh',
            scrollbarWidth: "none",
            overflowY: 'auto'
        }}>
            <div>
                <FormField
                    name="title"
                    type="text"
                    placeholder={t('forms.portfolio.title')}
                    onChange={formik.handleChange}
                    value={formik.values.title}
                    error={formik.touched.title && formik.errors.title}
                />
            </div>
            <div>
                <FormField
                    name="description"
                    type="text"
                    placeholder={t('forms.portfolio.description')}
                    onChange={formik.handleChange}
                    value={formik.values.description}
                    error={formik.touched.description && formik.errors.description}
                />
            </div>
            <div>
                <FormField
                    name="role"
                    type="text"
                    placeholder={t('forms.portfolio.role')}
                    onChange={formik.handleChange}
                    value={formik.values.role}
                    error={formik.touched.role && formik.errors.role}
                />
            </div>
            <div>
                <FormFileField
                    name="media"
                    type="file"
                    placeholder={t('forms.portfolio.upload_media')}
                    accept=".jpg, .jpeg, .png"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.media}
                    error={formik.touched.media && formik.errors.media}
                />
            </div>
            <div>
                <FormFileField
                    name="media2"
                    type="file"
                    placeholder={t('forms.portfolio.upload_media')}
                    accept=".jpg, .jpeg, .png"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.media2}
                    error={formik.touched.media2 && formik.errors.media2}
                />
            </div>
            <div>
                <FormFileField
                    name="media3"
                    type="file"
                    placeholder={t('forms.portfolio.upload_media')}
                    accept=".jpg, .jpeg, .png"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.media3}
                    error={formik.touched.media3 && formik.errors.media3}
                />
            </div>
            <div>
                <FormFileField
                    name="media4"
                    type="file"
                    placeholder={t('forms.portfolio.upload_media')}
                    accept=".jpg, .jpeg, .png"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.media4}
                    error={formik.touched.media4 && formik.errors.media4}
                />
            </div>
            <div>
                <FormFileField
                    name="media5"
                    type="file"
                    placeholder={t('forms.portfolio.upload_media')}
                    accept=".jpg, .jpeg, .png"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.media5}
                    error={formik.touched.media5 && formik.errors.media5}
                />
            </div>
            <div>
                <Button type="submit" className={styles.button}>
                    {t('forms.portfolio.add')}
                </Button>
            </div>
        </form>
    );
}

export default PortfolioForm;
